    <!-- Modal Container -->
    <div class="overflow-y-auto">
      <!-- Modal Content -->
      <div class="bg-white rounded-2xl shadow-2xl w-full max-w-4xl transform transition-all duration-300 ease-in-out">
        <!-- Modal Header -->
        <div class="w-full flex flex-row justify-between items-center p-4 border-b border-gray-200">
            <h6 class="text-2xl font-bold text-gray-800">{{ view.focusMealAndRoomOnly ? 'Edit meal plan & room type' : 'Service' }} <small class="text-gray-500 font-medium">{{ view.focusMealAndRoomOnly ? 'Amend meal plan and room type' : 'Amend service detail' }}</small></h6>
            <button type="button" class="text-gray-500 hover:text-gray-700 text-4xl transition-colors duration-200" (click)="closeModal()">
              &times;
            </button>
          </div>
  
        <!-- Modal Body -->
        <div class="p-6 space-y-6">
          <!-- Supplier and Service -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Supplier</label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.supplier">
            </div>
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Service</label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.service">
            </div>
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Payable Supplier</label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.payableSupplier">
            </div>
           
          </div>
          <!--  -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Supplier Description</label>
              <textarea type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.supplierDescription"></textarea>
            </div>
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Service Description</label>
              <textarea type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.serviceDescription"></textarea>
            </div>
          </div>
          <!-- Cost, ROE, and Sell -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Cost <sup class="text-gray-500">{{view.service.costCurrency}}</sup></label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.cost">
            </div>
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">ROE</label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.exchangeRateCurrent" readonly matTooltip="ROE adjust automatically">
            </div>
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Sell <sup class="text-gray-500">{{view.service.priceCurrency}}</sup></label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.price">
            </div>
            
          </div>
  
          <hr class="my-6 border-gray-200">
  
          <!-- Start and End Date/Time -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Start Date/Time</label>
              <input type="date" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.start">
            </div>
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">End Date/Time</label>
              <input type="date" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.end">
            </div>
          </div>
  
          <!-- Participant Counts -->
          <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Adults</label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.adultCount">
            </div>
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Teens</label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.teenCount">
            </div>
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Children</label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.childCount">
            </div>
            <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Infants</label>
              <input type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.infantCount">
            </div>
          </div>
          
          <hr/>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
           <div class="w-full">
              <label class="block font-medium text-gray-700 mb-1">Type</label>
              <select class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 shadow-sm" [(ngModel)]="view.service.searchType">
                <option [ngValue]="null">-- Select Type --</option>
                <option [ngValue]="1">Accommodation</option>
                <option [ngValue]="2">Flight</option>
                <option [ngValue]="3">Car Hire</option>
                <option [ngValue]="4">Activity</option>
                <option [ngValue]="8">Transfer</option>
                <option [ngValue]="9">Service</option>
                <option [ngValue]="10">Event</option>
              </select>
            </div>
             <div class="w-full">
              <label class="block  font-medium text-gray-700 mb-1">Basis</label>
              <select class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 shadow-sm" [(ngModel)]="basisChoice" (ngModelChange)="onBasisChange($event)">
                <option value="">-- Select Basis --</option>
                <option value="Per person">Per person</option>
                <option value="Per room">Per room</option>
                <option value="Total">Total</option>
                <option value="Per night">Per night</option>
                <option value="Per vehicle">Per vehicle</option>
                <option value="Other">Other</option>
              </select>
              <input *ngIf="basisChoice === 'Other'" type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm mt-2" [(ngModel)]="view.service.basis" placeholder="Enter basis">
            </div>
          </div>
          <hr class="my-6 border-gray-200">
  
          <!-- Amend Notes -->
          <div>
            <label class="block  font-medium text-gray-700 mb-1">Amend your notes</label>
            <textarea type="text" class="w-full rounded-md border border-slate-300 bg-white px-3 py-4 placeholder-slate-400 shadow-sm" [(ngModel)]="view.service.internalNote"></textarea>
          </div>
  
          <!-- Confirmation Section -->
          <div class="bg-gradient-to-r from-red-50 to-pink-50 p-6 rounded-lg text-center border border-red-100">
            <span class="text-red-700 font-semibold">I confirm that all information has been checked, <u>double-checked</u> and is correct.</span>
            <br />
            <label class="inline-flex items-center mt-3">
              <input type="checkbox" [(ngModel)]="view.service.chk1" class="form-checkbox h-5 w-5 text-blue-600 rounded-md border-gray-300 focus:ring-blue-500">
              <span class="ml-2  text-gray-700">Allow changes</span>
            </label>
            <br />
            <small class="text-gray-500">(Click above switch to allow saving)</small>
          </div>
        </div>
  
        <!-- Modal Footer -->
        <div class="flex justify-between p-6 border-t border-gray-200">
          <button type="button" class="text-gray-500 hover:text-gray-700 font-medium transition-colors duration-200" (click)="closeModal()">Close</button>
          <button *ngIf="user.agentType != 'AGENT'" [disabled]="!view.service.chk1" type="button" class="btn-primary" (click)="saveServiceItem()">
            Save
          </button>
        </div>
      </div>
    </div>
